import type { FieldValues } from 'react-hook-form'
import { Controller } from 'react-hook-form'

import { TextField } from '@mui/material'

import type { ControlledFieldBaseProps } from './types'

/**
 * MUI `TextField` bound to a react-hook-form `Controller`. Generic over the
 * form values type so it can back any RHF form.
 */
export function ControlledTextField<T extends FieldValues>({
  name,
  label,
  control,
  type = 'text',
  autoComplete,
}: ControlledFieldBaseProps<T> & { type?: string; autoComplete?: string }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          value={(field.value as string | undefined) ?? ''}
          id={name}
          label={label}
          type={type}
          fullWidth
          autoComplete={autoComplete}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
        />
      )}
    />
  )
}
